import createIcon from '../../createIcon';

/**
 * @component @name TextRotationNone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0gxMC41TDUuNzUgMTRINy44NUw4Ljc1IDExLjhIMTMuNzVMMTQuNjUgMTRIMTYuNzVMMTIgM1pNOS4zOCAxMEwxMS4yNSA0Ljk4TDEzLjEyIDEwSDkuMzhaTTE5Ljc1IDE4TDE2Ljc1IDE1VjE3SDQuMjVWMTlIMTYuNzVWMjFMMTkuNzUgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextRotationNone = createIcon('TextRotationNone', [
  [
    'path',
    {
      d: 'M12 3H10.5L5.75 14H7.85L8.75 11.8H13.75L14.65 14H16.75L12 3ZM9.38 10L11.25 4.98L13.12 10H9.38ZM19.75 18L16.75 15V17H4.25V19H16.75V21L19.75 18Z',
      key: '12i5ku',
    },
  ],
]);

export default TextRotationNone;
